import { isDev } from '@/components/utils/config'
import axios from 'axios'

let api
if (isDev) {
  if (process.env.NODE_ENV === 'local') {
    console.log('local')
    api = 'https://localhost:3000'
  } else {
    api = 'https://spotwork-server-dev-gqs5kyb4aa-an.a.run.app'
    // api = 'https://localhost:3000'
  }
} else {
  api = 'https://spotwork-server-prod-krwbx2bdoq-an.a.run.app'
}

const getHeaders = (token) => {
  if (token !== '') {
    return {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    }
  } else {
    return {
      'Content-Type': 'application/json'
    }
  }
}

class ApiError extends Error {
  constructor(message, code, data = null) {
    super(message)
    this.name = 'ApiError'
    this.code = code
    this.data = data
  }
}

const postRequest = async (formData, endpoint, token = '') => {
  const result = await axios
    .post(`${api}/${endpoint}`, formData, {
      headers: getHeaders(token)
    })
    .then((res) => res.data)
    .catch((error) => {
      console.error('error :', error.response)
      console.error('error :', error.message)
      if (error.response && error.response.data) {
        throw new ApiError(
          error.response.data.message || 'APIエラーが発生しました',
          error.response.data.code || 'unknown-error',
          error.response.data
        )
      }
      throw new ApiError(
        error.message || '予期せぬエラーが発生しました',
        'unknown-error'
      )
    })

  return result
}

// const getRequest = async (endpoint, token = '') => {

//   const result = await axios
//     .get(`${api}/${endpoint}`, {
//       headers: getHeaders(token)
//     })
//       .then((res) => res)
//       .catch((error) => {
//         console.error('error :', error.response)
//         console.error('error :', error.message)
//         return error
//       })
//   return result
// }

const receiveLinePayDeposit = async (token, uid, amount) => {
  const endpoint = 'deposit/line/send'
  const body = {
    uid: uid,
    amount: amount
  }
  return await postRequest(body, endpoint, token)
}

const receiveGMOTotalDeposit = async (token, uid, amount) => {
  const endpoint = 'deposit/gmo/total/send'
  const body = {
    uid: uid,
    amount: amount
  }
  return await postRequest(body, endpoint, token)
}

const recognizeEkyc = async (token, uid, frontImage, backImage = null) => {
  const endpoint = 'ekyc/recognize'
  const body = {
    uid: uid,
    frontImage: frontImage
  }
  if (backImage) body.backImage = backImage
  return await postRequest(body, endpoint, token)
}
const checkAndSaveEkycDataEkyc = async (
  token,
  uid,
  name,
  address,
  birthday,
  inputName,
  inputAddress,
  inputBirthday,
  frontImage,
  backImage = null,
  remarks = null
) => {
  const endpoint = 'ekyc/checkAndSaveEkycData'
  const body = {
    uid: uid,
    name: name,
    address: address,
    birthday: birthday,
    inputName: inputName,
    inputAddress: inputAddress,
    inputBirthday: inputBirthday,
    frontImage: frontImage
  }
  if (backImage) body.backImage = backImage
  if (remarks) body.remarks = remarks
  return await postRequest(body, endpoint, token)
}

const fetchEkycName = async (token, uid) => {
  const endpoint = 'ekyc/fetch/name'
  const body = {
    uid: uid
  }
  return await postRequest(body, endpoint, token)
}

const checkLinePayExists = async (token, uid, linePay) => {
  const endpoint = 'user/checkLinePayExists'
  const body = {
    uid: uid,
    linePay: linePay
  }
  return await postRequest(body, endpoint, token)
}
/**
 * LINE IDの重複チェックを行います
 *
 * @param {string} token
 * @param {string} lineid
 * @returns {Promise<{
 *   status: "success",
 *   isDuplication: boolean
 *  }>
 * } true:重複あり false:重複なし
 */
const checkLineIdDuplication = async (token, uid, lineId) => {
  const endpoint = 'user/checkLineIdDuplication'
  const body = {
    uid: uid,
    lineId: lineId
  }
  return await postRequest(body, endpoint, token)
}

/**
 * 電話番号の重複チェックを行います
 * @param {string} token
 * @param {string} telephoneNumber
 * @returns {Promise<{
 *   status: "success",
 *   isDuplication: boolean
 *  }>
 * } true:重複あり false:重複なし
 */
const checkTelephoneNumberDuplication = async (token, uid, telephoneNumber) => {
  const endpoint = 'user/checkTelephoneNumberDuplication'
  const body = {
    uid: uid,
    telephoneNumber: telephoneNumber
  }
  return await postRequest(body, endpoint, token)
}

const checkIsTextFieldDataDuplicated = async (
  token,
  uid,
  workId,
  elementId,
  value
) => {
  const endpoint = 'work/checkIsTextFieldDataDuplicated'
  const body = {
    uid: uid,
    workId: workId,
    elementId: elementId,
    value: value
  }
  return await postRequest(body, endpoint, token)
}

const checkIsTextFieldDataExcludedNGList = async (
  token,
  uid,
  workId,
  elementId,
  value
) => {
  const endpoint = 'work/checkIsTextFieldDataExcludedNGList'
  const body = {
    uid: uid,
    workId: workId,
    elementId: elementId,
    value: value
  }
  return await postRequest(body, endpoint, token)
}

// Add new offer-related API functions
const acceptOffer = async (params, token = '') => {
  const endpoint = 'offer/accept'
  const body = {
    offerId: params.offerId,
    companyId: params.companyId,
    userId: params.userId,
    userAccessibleUserId: params.userAccessibleUserId,
    scheduledDate: params.scheduledDate?.toISOString(),
    orderId: params.orderId,
    order: params.order,
    currentLocation: params.currentLocation
  }
  return await postRequest(body, endpoint, token)
}

const rejectOffer = async (
  offerId,
  orderId,
  companyId,
  userId,
  userAccessibleUserId,
  token = ''
) => {
  const endpoint = 'offer/reject'
  const body = {
    offerId,
    orderId,
    companyId,
    userId,
    userAccessibleUserId
  }
  return await postRequest(body, endpoint, token)
}

const updateEmail = async (token, uid, oldEmail, newEmail) => {
  const endpoint = 'userAuth/updateEmail'
  const body = {
    uid: uid,
    oldEmail: oldEmail,
    newEmail: newEmail
  }
  return await postRequest(body, endpoint, token)
}

const verifyEmail = async (token, uid, code) => {
  const endpoint = 'userAuth/verifyEmail'
  const body = {
    uid: uid,
    code: code
  }
  return await postRequest(body, endpoint, token)
}

const getBankAccount = async (token, uid) => {
  const endpoint = 'user/gmoBankAccount'
  const body = {
    uid: uid
  }
  return await postRequest(body, endpoint, token)
}

const deleteBankAccount = async (token, uid) => {
  const endpoint = 'deposit/gmo/total/deleteBank'
  const body = {
    uid: uid
  }
  return await postRequest(body, endpoint, token)
}

const spotworkAPI = {
  receiveLinePayDeposit,
  receiveGMOTotalDeposit,
  recognizeEkyc,
  checkAndSaveEkycDataEkyc,
  fetchEkycName,
  checkLinePayExists,
  checkLineIdDuplication,
  checkTelephoneNumberDuplication,
  checkIsTextFieldDataDuplicated,
  checkIsTextFieldDataExcludedNGList,
  acceptOffer,
  rejectOffer,
  updateEmail,
  verifyEmail,
  getBankAccount,
  deleteBankAccount
}

export default spotworkAPI
